import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import {
	Alert,
	Button,
	Col,
	Collapse,
	Divider,
	Image,
	List,
	Row,
	Space,
} from 'antd';
import { MasterData } from '@/libs/fleet-api/services/master-data';
import { FC, useState } from 'react';

// Bank Logos
import mandiri from '@/assets/images/banks/mandiri.png';
import bni from '@/assets/images/banks/bni.png';
import bca from '@/assets/images/banks/bca.png';
import bri from '@/assets/images/banks/bri.png';
import bjb from '@/assets/images/banks/bjb.png';
import btn from '@/assets/images/banks/btn.png';
import cimb from '@/assets/images/banks/cimb.png';
import danamon from '@/assets/images/banks/danamon.png';
import ocbc from '@/assets/images/banks/ocbc.png';
import permata from '@/assets/images/banks/permata.png';

// Statement Samples
// Mandiri
import mandiri1 from '@/assets/images/statement-examples/mandiri/1.png';
import mandiri2 from '@/assets/images/statement-examples/mandiri/2.png';
import mandiri3 from '@/assets/images/statement-examples/mandiri/3.png';
import mandiri4 from '@/assets/images/statement-examples/mandiri/4.png';
import mandiri5 from '@/assets/images/statement-examples/mandiri/5.png';
import mandiri6 from '@/assets/images/statement-examples/mandiri/6.png';
import mandiribad1 from '@/assets/images/statement-examples/mandiri/bad/1.png';
// BNI
import bni1 from '@/assets/images/statement-examples/bni/1.png';
import bni2 from '@/assets/images/statement-examples/bni/2.png';
import bni3 from '@/assets/images/statement-examples/bni/3.png';
import bni4 from '@/assets/images/statement-examples/bni/4.png';
import bni5 from '@/assets/images/statement-examples/bni/5.png';
import bni6 from '@/assets/images/statement-examples/bni/6.png';
import bnibad1 from '@/assets/images/statement-examples/bni/bad/1.png';
import bnibad2 from '@/assets/images/statement-examples/bni/bad/2.png';
// BCA
import bca1 from '@/assets/images/statement-examples/bca/1.png';
import bca2 from '@/assets/images/statement-examples/bca/2.png';
import bca3 from '@/assets/images/statement-examples/bca/3.png';
import bca4 from '@/assets/images/statement-examples/bca/4.png';
// BRI
import bri1 from '@/assets/images/statement-examples/bri/1.png';
import bri2 from '@/assets/images/statement-examples/bri/2.png';
import bri3 from '@/assets/images/statement-examples/bri/3.png';
import bri4 from '@/assets/images/statement-examples/bri/4.png';
import bri5 from '@/assets/images/statement-examples/bri/5.png';
import bribad1 from '@/assets/images/statement-examples/bri/bad/1.png';
// BJB
import bjb1 from '@/assets/images/statement-examples/bjb/1.png';
import bjb2 from '@/assets/images/statement-examples/bjb/2.png';
import bjb3 from '@/assets/images/statement-examples/bjb/3.png';
import bjb4 from '@/assets/images/statement-examples/bjb/4.png';
// BTN
import btn1 from '@/assets/images/statement-examples/btn/1.png';
import btn2 from '@/assets/images/statement-examples/btn/2.png';
import btn3 from '@/assets/images/statement-examples/btn/3.png';
import btnbad1 from '@/assets/images/statement-examples/btn/bad/1.png';
// CIMB
import cimb1 from '@/assets/images/statement-examples/cimb/1.png';
import cimb2 from '@/assets/images/statement-examples/cimb/2.png';
import cimb3 from '@/assets/images/statement-examples/cimb/3.png';
// Danamon
import danamon1 from '@/assets/images/statement-examples/danamon/1.png';
import danamon2 from '@/assets/images/statement-examples/danamon/2.png';
import danamonbad1 from '@/assets/images/statement-examples/danamon/bad/1.png';
// OCBC
import ocbc1 from '@/assets/images/statement-examples/ocbc/1.png';
import ocbc2 from '@/assets/images/statement-examples/ocbc/2.png';
import ocbc3 from '@/assets/images/statement-examples/ocbc/3.png';
import ocbc4 from '@/assets/images/statement-examples/ocbc/4.png';
// Permata
import permata1 from '@/assets/images/statement-examples/permata/1.png';
import permata2 from '@/assets/images/statement-examples/permata/2.png';
import permata3 from '@/assets/images/statement-examples/permata/3.png';
import permata4 from '@/assets/images/statement-examples/permata/4.png';

type ModalData = {
	customerId: string;
	bankOptions: MasterData[];
};

export const useOCRBankStatementSampleModal = () => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => {
			setModalData(data);
		},
		close: () => setModalData(undefined),
	};
};

const OCRBankStatementSampleModal: FC<
	ReturnType<typeof useOCRBankStatementSampleModal>
> = (props) => {
	const bankImages: Record<string, string> = {
		mandiri,
		bni,
		bca,
		bri,
		bjb,
		btn,
		cimb,
		danamon,
		ocbc,
		permata,
	};
	const statementImages: Record<string, string> = {
		mandiri1,
		mandiri2,
		mandiri3,
		mandiri4,
		mandiri5,
		mandiri6,
		mandiribad1,
		bni1,
		bni2,
		bni3,
		bni4,
		bni5,
		bni6,
		bnibad1,
		bnibad2,
		bca1,
		bca2,
		bca3,
		bca4,
		bri1,
		bri2,
		bri3,
		bri4,
		bri5,
		bribad1,
		bjb1,
		bjb2,
		bjb3,
		bjb4,
		btn1,
		btn2,
		btn3,
		btnbad1,
		cimb1,
		cimb2,
		cimb3,
		danamon1,
		danamon2,
		danamonbad1,
		ocbc1,
		ocbc2,
		ocbc3,
		ocbc4,
		permata1,
		permata2,
		permata3,
		permata4,
	};
	const banks = [
		{
			id: 'mandiri',
			button: 'mandiri.png',
			statements: 6,
			notSupporteds: 1,
		},
		{
			id: 'bni',
			button: 'bni.png',
			statements: 6,
			notSupporteds: 2,
		},
		{
			id: 'bca',
			button: 'bca.png',
			statements: 4,
			notSupporteds: 0,
		},
		{
			id: 'bri',
			button: 'bri.png',
			statements: 5,
			notSupporteds: 1,
		},
		{
			id: 'bjb',
			button: 'bjb.png',
			statements: 4,
			notSupporteds: 0,
		},
		{
			id: 'btn',
			button: 'btn.png',
			statements: 3,
			notSupporteds: 1,
		},
		{
			id: 'cimb',
			button: 'cimb.png',
			statements: 3,
			notSupporteds: 0,
		},
		{
			id: 'danamon',
			button: 'danamon.png',
			statements: 2,
			notSupporteds: 1,
		},
		{
			id: 'ocbc',
			button: 'ocbc.png',
			statements: 4,
			notSupporteds: 0,
		},
		{
			id: 'permata',
			button: 'permata.png',
			statements: 4,
			notSupporteds: 0,
		},
	];
	const [selectedBank, setSelectedBank] = useState<string>(banks[0].id);
	const [selectedBankIndex, setSelectedBankIndex] = useState<number>(0);

	return (
		<FleetModal
			open={props.isOpen}
			width="100vw"
			closable={false}
			buttonPosition="end"
			footer={<Button onClick={() => props.close()}>BACK</Button>}
		>
			<Space
				direction="vertical"
				style={{ display: 'flex' }}
				size={'large'}
			>
				<FleetTitle>View File</FleetTitle>
				<Row gutter={10}>
					<Col span={5}>
						<List
							header={<div>Jenis Bank</div>}
							bordered
							dataSource={banks}
							renderItem={(item) => (
								<List.Item
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									<Button
										onClick={() => {
											setSelectedBank(item.id.toString());
											const bankIndex = banks.findIndex(
												(bank) => bank.id === item.id,
											);
											setSelectedBankIndex(bankIndex);
										}}
										style={{
											width: 200,
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											border:
												selectedBank === item.id.toString()
													? '3px solid #1557BC'
													: '1px solid #d9d9d9',
										}}
									>
										<img src={bankImages[item.id]} />
									</Button>
								</List.Item>
							)}
						/>
					</Col>
					<Col span={19}>
						<Collapse
							accordion
							defaultActiveKey={0}
							items={[
								{
									label: 'Contoh File Supported',
									children: (
										<>
											{Array.from(
												{ length: banks[selectedBankIndex].statements },
												(_, i) => (
													<>
														<Divider orientation="left">
															Contoh File Supported {i + 1}
														</Divider>
														<Image
															key={i}
															src={statementImages[`${selectedBank}${i + 1}`]}
															alt={`${selectedBank} Supported Statement ${i + 1}`}
														/>
													</>
												),
											)}
										</>
									),
								},
								{
									label: 'Contoh File Not Supported',
									children: (
										<>
											{banks[selectedBankIndex].notSupporteds === 0 ? (
												<Alert
													message={<>Tidak ada Contoh File Not Supported</>}
													type="info"
													showIcon
												/>
											) : (
												Array.from(
													{ length: banks[selectedBankIndex].notSupporteds },
													(_, i) => (
														<>
															<Divider orientation="left">
																Contoh File Not Supported {i + 1}
															</Divider>
															<Image
																key={i}
																src={
																	statementImages[`${selectedBank}bad${i + 1}`]
																}
																alt={`${selectedBank} Not Supported Statement ${i + 1}`}
															/>
														</>
													),
												)
											)}
										</>
									),
								},
							]}
						/>
					</Col>
				</Row>
			</Space>
		</FleetModal>
	);
};

export default OCRBankStatementSampleModal;
